import React, { Component } from "react";
import Third from "../../../components/Third/Third";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Social_BenefitsForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente de Social_benefits con sus respectivos parámetros.
================================================================================ */

class ThirdForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <Third/>
        )
    }
}

export default ThirdForm;